const categoriasCNH = [{
        text: "Categoria A",
        value: "A"
    },
    {
        text: "Categoria B",
        value: "B"
    },
    {
        text: "Categoria C",
        value: "C"
    },
    {
        text: "Categoria D",
        value: "D"
    },
    {
        text: "Categoria E",
        value: "E"
    },
    {
        text: "Categoria ACC",
        value: "ACC"
    },
    {
        text: "Categoria AB",
        value: "AB"
    },
    {
        text: "Categoria AC",
        value: "AC"
    },
    {
        text: "Categoria AD",
        value: "AD"
    },
    {
        text: "Categoria AE",
        value: "AE"
    }
];

module.exports = {
    categoriasCNH
}